export default function accordionScript() {
  (function () {
    var accordions = document.querySelectorAll('.accordion__title');
    var openClass = '--is-open';

    function onClick(el) {
      if (el.target.classList.contains('--is-closed-others')) {
        var openedAccordions = document.querySelectorAll('.accordion__title.--is-open');
        if (openedAccordions) {
          openedAccordions.forEach((node) => {
            if (!node.isSameNode(el.target)) {
              node.classList.remove(openClass);
              node.parentNode.classList.remove(openClass);
              node.nextElementSibling.classList.remove(openClass);
            }
            return null;
          });
        }
      }
      el.target.classList.toggle(openClass);
      el.target.parentNode.classList.toggle(openClass);
      el.target.nextElementSibling.classList.toggle(openClass);
    }

    for (let i = 0; i < accordions.length; i++) {
      accordions[i].addEventListener('click', onClick);
    }
  })();
}
